module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "mdl-card__supporting__text"
  }, [_c('div', {
    staticClass: "interval-wrapper"
  }, [_c('h5', {
    staticClass: "interval"
  }, [_vm._v("Intervall: "), _c('v-datefield', {
    attrs: {
      "id": "start",
      "label": "Start",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _c('v-datefield', {
    attrs: {
      "id": "end",
      "label": "Slut",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)]), _c('form', {
    staticClass: "gridform",
    attrs: {
      "id": "new_activity"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('fieldset', [_c('legend', [_vm._v("Ny aktivitet")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('v-textfield', {
    attrs: {
      "id": "name",
      "name": "ActivityName",
      "label": "Namn",
      "validate": "required"
    },
    model: {
      value: (_vm.new_activity.name),
      callback: function($$v) {
        _vm.$set(_vm.new_activity, "name", $$v)
      },
      expression: "new_activity.name"
    }
  })], 1), _c('div', {
    staticClass: "cell"
  }, [_c('v-selectfield', {
    attrs: {
      "id": "type",
      "label": "Typ",
      "options": _vm.types
    },
    model: {
      value: (_vm.new_activity.activity_type_uid),
      callback: function($$v) {
        _vm.$set(_vm.new_activity, "activity_type_uid", $$v)
      },
      expression: "new_activity.activity_type_uid"
    }
  })], 1), _c('div', {
    staticClass: "cell date"
  }, [_c('v-datefield', {
    attrs: {
      "id": "new_start",
      "label": "Start",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.new_activity.start),
      callback: function($$v) {
        _vm.$set(_vm.new_activity, "start", $$v)
      },
      expression: "new_activity.start"
    }
  })], 1), _c('div', {
    staticClass: "cell date"
  }, [_c('v-datefield', {
    attrs: {
      "id": "new_end",
      "label": "Slut",
      "validate": 'date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.new_activity.end),
      callback: function($$v) {
        _vm.$set(_vm.new_activity, "end", $$v)
      },
      expression: "new_activity.end"
    }
  })], 1), _c('div', {
    staticClass: "cell tools"
  }, [_c('v-fab-button', {
    attrs: {
      "id": "save_button",
      "icon": "save"
    },
    on: {
      "clicked": _vm.addActivity
    }
  })], 1)])])])])]), _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', [_vm._v("Aktiviteter"), _c('br'), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('name'),
    on: {
      "click": function($event) {
        _vm.sort('name')
      }
    }
  }, [_vm._v("Aktivitet")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('activity_type_label'),
    on: {
      "click": function($event) {
        _vm.sort('activity_type_label')
      }
    }
  }, [_vm._v("Typ")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('start'),
    on: {
      "click": function($event) {
        _vm.sort('start')
      }
    }
  }, [_vm._v("Start")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('end'),
    on: {
      "click": function($event) {
        _vm.sort('end')
      }
    }
  }, [_vm._v("Slut")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Ändra/radera")])])]), (_vm.are_loaded.activities) ? _c('tbody', _vm._l((_vm.sortedActivities(_vm.sort_key)), function(activity, idx) {
    return _c('tr', {
      key: idx,
      attrs: {
        "id": activity.uid,
        "data-order": idx
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [(_vm.edit_uid != activity.uid) ? _c('span', [_vm._v(_vm._s(activity.name))]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('v-textfield', {
      attrs: {
        "id": "name",
        "name": "ActivityName",
        "label": "Namn",
        "validate": "required"
      },
      model: {
        value: (_vm.edit_activity.name),
        callback: function($$v) {
          _vm.$set(_vm.edit_activity, "name", $$v)
        },
        expression: "edit_activity.name"
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [(_vm.edit_uid != activity.uid) ? _c('span', [_vm._v(_vm._s(activity.activity_type_label))]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('v-selectfield', {
      attrs: {
        "id": "type",
        "label": "Typ",
        "options": _vm.types
      },
      model: {
        value: (_vm.edit_activity.activity_type_uid),
        callback: function($$v) {
          _vm.$set(_vm.edit_activity, "activity_type_uid", $$v)
        },
        expression: "edit_activity.activity_type_uid"
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [(_vm.edit_uid != activity.uid) ? _c('span', [_vm._v(_vm._s(activity.start))]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('v-datefield', {
      attrs: {
        "id": "edit_start",
        "label": "Start",
        "validate": 'date_format:YYYY-MM-DD'
      },
      model: {
        value: (_vm.edit_activity.start),
        callback: function($$v) {
          _vm.$set(_vm.edit_activity, "start", $$v)
        },
        expression: "edit_activity.start"
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [(_vm.edit_uid != activity.uid) ? _c('span', [_vm._v(_vm._s(activity.end))]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('v-datefield', {
      attrs: {
        "id": "edit_end",
        "label": "Slut",
        "validate": 'date_format:YYYY-MM-DD'
      },
      model: {
        value: (_vm.edit_activity.end),
        callback: function($$v) {
          _vm.$set(_vm.edit_activity, "end", $$v)
        },
        expression: "edit_activity.end"
      }
    }) : _vm._e()], 1), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.deleteActivity(activity)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])]), (_vm.edit_uid != activity.uid) ? _c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.editActivity(activity)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("edit")])]) : _vm._e(), (_vm.edit_uid == activity.uid) ? _c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.updateActivity()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("save")])]) : _vm._e()])])
  })) : _vm._e()]), _c('v-dialog-confirm', {
    attrs: {
      "id": "confirm",
      "message": _vm.show.message
    },
    on: {
      "ok": function($event) {
        _vm.show.action()
      },
      "cancel": _vm.cancel
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title"
  }, [_c('div', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Aktiviteter")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-324c9d7c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Activities.vue
// module id = 510
// module chunks = 1